import { useEffect, useState } from "react";
import useWilmaUsers from "../../data/useWilmaUsers";
import { IWilmaUser } from "../../models/auth/WilmaUser";
import SelectInput from "../shared/Inputs/SelectInput";
import { set } from "lodash";

export default function ExporterSelect({ register, setValue, watch, hideLabel }: { register: any, setValue: any, watch: any, hideLabel?: boolean }) {
  const [exporters, setExporters] = useState<any[]>([]);

  const { wilmaUsers } = useWilmaUsers();

  useEffect(() => {
    if (!wilmaUsers.data?.data) return;
    if (wilmaUsers.isLoading) return;

    const exps = wilmaUsers.data.data.filter((u) => u.userClaims.some((c) => c.type === "isExporter" && c.value === "true")).map((u) => ({ id: u.id, name: `${u.fullname}` }));
    setExporters([{ id: null, name: "Select an exporter"}, ...exps]);
  }, [wilmaUsers.data, wilmaUsers.isLoading]); 
  
  return (
    <SelectInput
      label={hideLabel ? undefined : "Exporter"}
      register={register}
      registerName={"userId"}
      setValue={setValue}
      watch={watch}
      options={exporters}
    />
  );
}